<template>
  <div class="highway">
    <div class="">
      <!-- <div class="tabs_case">
        <CButtonsSeparate
          @Cbtns_sep="fnGetCbtns"
          class="CARD_body_tabs"
          :dButtons1="dButtons1"
          :disabled="false"
          :dButtons1_current="dButtons1_current" />
      </div> -->
      <div class="change_asset">
        <CSelect
          v-if="!assetName2.length && assetName.length > 1"
          class="ss chart3_cascasder"
          @CSelect_select_val="changeAsset"
          :options="assetName"
          :clearable="false"
          :default="current_asset">
          选择资产:</CSelect
        >
        <CCascader
          v-if="assetName2.length"
          ref="ccsc"
          :options="assetName2"
          :default="current_asset"
          :checkStrictly="true"
          custWidth="400px"
          @CCascader_select_change="select_change"
          >选择资产:
          <template #tooltip="{ data }">
            <el-tooltip effect="dark" placement="right" v-if="cascader_tooltip[data.value]">
              <template #content>
                <div style="width: 15vw" v-html="cascader_tooltip[data.value]"></div>
              </template>
              <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
            </el-tooltip>
          </template>
        </CCascader>
        <CButtonsSeparate
          @Cbtns_sep="fnGetCbtns"
          class="ss CARD_body_tabs"
          :dButtons1="dButtons1"
          :disabled="false"
          :dButtons1_current="dButtons1_current">
          <template #tooltip="{ item }">
            <el-tooltip effect="dark" placement="right" v-if="item_maps[item]">
              <template #content>
                <div style="width: 15vw" v-html="item_maps[item]"></div>
              </template>
              <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
            </el-tooltip>
          </template>
        </CButtonsSeparate>
      </div>
      <MainPerformance
        ref="mainPerformance"
        v-if="dButtons1_current == '主要表现'"
        :current_asset="current_asset" />
      <MarketTrends
        ref="marketTrends"
        v-if="dButtons1_current == '市场趋势'"
        :current_asset="current_asset" />
      <IframePage
        v-if="dButtons1_current === '项目租赁表现'"
        key="项目租赁表现"
        :page_path="current_sub_asset.url_2 + '&colorMode=' + currentTheme" />
      <IframePage
        key="区域市场表现"
        v-if="dButtons1_current === '区域市场表现'"
        :page_path="current_sub_asset.url_1 + '&colorMode=' + currentTheme" />
    </div>
    <div class="CARD" v-if="!current_sub_asset.name">
      <Calculator ref="calculator" :assetName="assetName" />
    </div>
  </div>
</template>

<script>
// import CButtons from '@/components/Basic/CButtons';
import CButtonsSeparate from '@/components/Basic/CButtons_separate';
import CSelect from '@/components/Basic/CSelect';
import CCascader from '@/components/Basic/CCascader';

import MainPerformance from './MainPerformance.vue';
import MarketTrends from './MarketTrends.vue';
import Calculator from './Calculator.vue';
import IframePage from '../IframePage.vue';
export default {
  components: {
    CButtonsSeparate,
    MainPerformance,
    MarketTrends,
    Calculator,
    CSelect,
    IframePage,
    CCascader,
  },
  props: {
    _asset_name: Array,
  },
  data() {
    return {
      item_maps: {
        项目租赁表现:
          '提供REITs项目在租赁市场的运营情况，包含项目基础信息、租户结构、租户搬迁信息等',
        区域市场表现: '提供REITs项目所在板块的市场表现情况，包含板块的供需租金走势、产业结构等',
      },
      current_asset: '',
      current_sub_asset: {},
      ROOTFONTFIZE: 0,
      dButtons1: ['主要表现', '市场趋势'],
      dButtons1_current: '主要表现',
      CODE: '',
    };
  },
  created() {},
  mounted() {
    this.fnGetWidth();
    window.addEventListener('resize', this.funResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  methods: {
    getIframePath([v1, v2]) {
      console.clear();
      console.log(this._asset_name, v1, v2);
      const node = this._asset_name.find((item) => item['资产名称'] === v1);
      return node.children.find((c) => c.name === v2);
    },
    select_change(v, v2) {
      if (v.length === 1) {
        this.dButtons1_current = '主要表现';
        this.dButtons1 = ['主要表现', '市场趋势'];
        this.changeAsset(v[v.length - 1]);
      } else {
        this.dButtons1 = ['主要表现', '市场趋势', '项目租赁表现', '区域市场表现'];
        this.current_sub_asset = this.getIframePath(v);
        this.dButtons1_current = v2 ? v2 : '项目租赁表现';
      }
    },
    changeAsset(v) {
      this.current_asset = v;
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    funResize() {
      this.fnGetWidth();
    },

    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
    },
    fnGetCbtns(data) {
      this.CODE = window.sessionStorage.getItem('CURRENTCODE');
      const check = (v) => ['项目租赁表现', '区域市场表现'].includes(v);
      if (check(this.dButtons1_current) && !check(data)) {
        this.$refs.ccsc.value = this.current_asset;
        this.$refs.ccsc.handleChange([this.current_asset]);
        this.current_sub_asset = {};
      } else {
        this.dButtons1_current = data;
      }
    },
    reload() {
      this.CODE = window.sessionStorage.getItem('CURRENTCODE');
    },
  },
  computed: {
    asset_name() {
      return ['整体', ...this._asset_name.map((item) => item['资产名称'])];
    },
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme;
    },
    assetName() {
      return this.asset_name.map((item) => ({
        label: item,
        value: item,
      }));
    },
    assetName2() {
      const flag = this._asset_name.some((item) => item.children.length);
      const list = [
        {
          label: '整体',
          value: '整体',
        },
        ...this._asset_name.map((item) => ({
          label: item['资产名称'],
          value: item['资产名称'],
          children: item.children.map((c) => ({
            label: item['资产名称'] + '-' + c.name,
            value: c.name,
          })),
        })),
      ];
      return flag ? list : [];
    },
    cascader_tooltip() {
      return this._asset_name.reduce((p, c) => {
        c.children.forEach((item) => {
          p[item.name] = item.caliber;
        });
        return p;
      }, {});
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.fnGetTheme();
    },
    asset_name: {
      handler(now) {
        this.current_asset = now[0];
      },
      immediate: true,
    },
    '$route.query': {
      handler: function () {
        const { name, type } = this.$route.query;
        if (name && type) {
          const v = name.split(',');
          setTimeout(() => {
            this.$refs.ccsc.value = v;
            this.$refs.ccsc.handleChange(v);
            this.current_asset = v[0];
            this.dButtons1_current = type;
            this.$router.replace({ query: '' });
          }, 200);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.change_asset {
  display: flex;
  padding: 20px 0;
  .ss:first-child {
    margin-left: 0 !important;
  }
}

.highway {
  .CARD {
    border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
    background-color: var(--charts_bgc);
    padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
    margin-top: calc(var(--ROOTFONTFIZE) * (50 / 144));
    margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
    .tabs_case {
      padding-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
    }
  }
}
</style>
